import {React, useEffect} from 'react';
import { useLocation } from "react-router-dom";
import "./kvkk.css"; // CSS dosyanızın yolu
import Header2 from "../../header2/index-two";
import { Footer2 } from "../../footer2";
import usePageTracking from '../../../hooks/usePageTracking';
const KvkkPage = () => {
      usePageTracking("kvkk");

      const { pathname } = useLocation();
      
        useEffect(() => {
          // Anında yukarı sıfırla (hiç animasyon yok)
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"   // <--- ÖNEMLİ KISIM
          });
        }, [pathname]);
        
  return (
    <div className="main-wrapper">
      <Header2/>
      {/* ======================================================= */}
      {/* KİŞİSEL VERİLERİN KORUNMASI (KVKK) AYDINLATMA METNİ */}
      {/* ======================================================= */}
      <section className="kvkk-section">
        <div className="kvkk-container">
          <div className="kvkk-background">
            <div className="kvkk-inner">
              <div className="kvkk-heading">
                <h2>KİŞİSEL VERİLERİN KORUNMASI (KVKK) AYDINLATMA METNİ</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="kvkk-content mb-5">
          <h3 className="kvkk-section-title">1. Veri Sorumlusu</h3>
          <p className="kvkk-paragraph">
             Topkapı Mah. Kahalbaşı Sok. No:31/1 - Fatih/İstanbul adresinde mukim İdeal Kültür Yayıncılık Reklam ve Organizasyon SAN. TİC. LTD. ŞTİ. (İDEAL) olarak kişisel verilerinizin güvenliğine önem veriyoruz.
          </p>
          <h3 className="kvkk-section-title">2. İşlenen Veriler ve Amaçlar</h3>
          <ul className="kvkk-list">
            <li>
              <strong>Yayıncılar İçin:</strong> Başvuru formunda beyan edilen isim, iletişim (e-mail, telefon), adres ve yayın bilgileri (ISSN, Editör bilgisi vb.) ; sözleşme süreçlerinin yönetilmesi ve veri tabanı indeksleme hizmetinin sunulması amacıyla işlenir.
            </li>
            <li>
              <strong>Kullanıcılar İçin:</strong> Platforma kayıt sırasında alınan üyelik bilgileri, kullanıcı deneyimini iyileştirmek ve erişim yetkilerini yönetmek amacıyla işlenir.
            </li>
          </ul>

          <h3 className="kvkk-section-title">3. Verilerin Aktarılması</h3>
          <p className="kvkk-paragraph">
            Kişisel verileriniz, yasal yükümlülükler hariç olmak üzere, yazılı izniniz olmaksızın üçüncü kişilere açıklanmaz ve devredilmez. Ancak, sistem uluslararası arama motorları tarafından indekslendiği için dergi künye bilgilerinin (Editör ismi vb.) kamuya açık hale geleceği tarafınızca kabul edilmiştir.
          </p>

          <h3 className="kvkk-section-title">4. Haklarınız</h3>
          <p className="kvkk-paragraph">
            KVKK uyarınca; verilerinizin işlenip işlenmediğini öğrenme, düzeltme talep etme veya verilerinizin silinmesini (anonim hale getirilmesini) isteme hakkına sahipsiniz. Yayıncılar için sistemden ayrılma talebi durumunda, veriler sistem işleyişini aksatmayacak şekilde kademeli olarak kaldırılır.
          </p>

          <h3 className="kvkk-section-title">5. İletişim</h3>
          <p className="kvkk-paragraph">
            Veri haklarınızla ilgili taleplerinizi <span className="kvkk-highlight">idealonline@idealkultur.com</span> adresine iletebilirsiniz.
          </p>
        </div>
      </section>
      <Footer2 />
    </div>
  );
};

export default KvkkPage;